import { Form } from "antd";
import { useNavigate } from "react-router-dom";

import { forgotPasswordPayload } from "../../../utils/types";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import { useForgotPassword } from "./ForgotPasswordQuery.tsx";

export default function useForgotPasswordContainer() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onForgotPasswordSuccess = (payload: forgotPasswordPayload) => {
    navigate(NavigationRoutes.AUTH_ROUTES.OTP_VERIFICATION, {
      state: { email: payload?.email, role: payload?.role || "Admin" },
    });
  };

  const { mutate: forgotPasswordMutate, isPending } = useForgotPassword(
    onForgotPasswordSuccess
  );

  const handleSubmit = (data: forgotPasswordPayload) => {
    forgotPasswordMutate({ ...data, role: "Admin" });
  };

  const handleLogin = () => {
    navigate(NavigationRoutes.AUTH_ROUTES.LOGIN);
  };

  const handleForgotPassword = () => {};
  return {
    form,   
    navigate,
    isPending,
    handleSubmit,
    handleLogin,
    handleForgotPassword,
  };
}
